import styled from '@emotion/styled'

import { heightButton, resetInput } from '@/styles/mixins'
import { border, colors, transitions } from '@/styles/theme'
import { InputTextStyles, LegiaMedium, H2Styles } from '@/styles/typography'
import { mediaUp } from '@/styles/media'

export const InputBaseStyles = styled.input`
  width: 100%;
  font-family: Nunito;
  font-size: 12px;
  color: ${colors.navyBlue};
  font-weight: 600;
  box-sizing: border-box;
  @media (min-width: 769px) {
    width: 320px;
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    width: 380px;
    font-size: 18px;
    padding: 8px;
  }

  &::placeholder {
    color: ${colors.navyBlue};
    font-weight: 600;
    font-size: 12px;
    opacity: 0.7;
    @media (min-width: 769px) {
      font-size: 16px;
    }
    @media (min-width: 1024px) {
      font-size: 18px;
    }
  }
`

export const InputComponent = styled.input<{
  invalid?: boolean
  active?: boolean
  disabled?: boolean
  uppercase?: boolean
}>`
  ${resetInput};
  ${heightButton};
  ${InputTextStyles};

  border-radius: ${border.radius};
  box-shadow: ${border.shadow};
  background-color: ${props => (props.disabled ? `var(--tint)` : colors.white)};
  ${props => props.uppercase && 'text-transform: uppercase'};
  border: 1px solid
    ${props =>
      props.active
        ? `var(--accentFirst)`
        : props.invalid
        ? colors.darkCoral
        : 'transparent'};
  color: var(--main);
  transition: border-color ${transitions.base};
  width: 100%;

  &:focus {
    border-color: var(--accentFirst);
  }

  ${mediaUp('lg')} {
    border-width: 2px;
  }

  .legia-warszawa & {
    ${LegiaMedium};
    color: var(--mainCustom);
    border-radius: 0;

    border: 1px solid
      ${props =>
        props.active
          ? `var(--accentFirstCustom)`
          : props.invalid
          ? `var(--errorCustom)`
          : 'transparent'};

    &:focus {
      border-color: var(--accentFirstCustom);
    }

    ${mediaUp('lg')} {
      border-width: 2px;
    }
  }
`

export const DateInput = styled.input`
  width: 70px;
  font-family: 'Nunito';
  font-size: 12px;
  color: ${colors.blueyGrey};
  text-align: center;

  font-weight: 600;
  &::placeholder {
    color: ${colors.blueyGrey};
  }

  @media (min-width: 769px) {
    font-size: 16px;
    width: 90px;
    color: ${colors.navyBlue};
    &::placeholder {
      opacity: 0.7;
      color: ${colors.navyBlue};
    }
  }

  @media (min-width: 1024px) {
    font-size: 18px;
    width: 104px;
  }
`

export const NumberInput = styled.input`
  ${resetInput};
  ${H2Styles};

  width: 72px;
  height: 40px;
  border-radius: 10px;
  padding: 4px 8px;
  text-align: center;
  border: 2px solid transparent;

  transition: background-color ${transitions.base};
  background-color: var(--tint);

  &:focus {
    border-color: var(--accentFirst);
  }

  ${mediaUp('lg')} {
    font-size: 36px;
    line-height: 1.33;

    width: 102px;
    height: 56px;
  }
`

export const SearchInput = styled.input`
  display: flex;
  width: 100%;
  padding: 8px 18px;
  align-items: center;
  gap: 10px;
  border-radius: 15px;
  border: 1px solid ${colors.offWhite};
  background: ${colors.white};
  color: ${colors.navyBlue};
  font-family: Nunito;
  font-size: 12px;
  font-weight: 600;
  margin: 32px 0;
  &:placeholder {
    color: ${colors.navyBlue};
  }

  ${mediaUp('md')} {
    width: 100%;
    max-width: 100%;
  }
`
